<template>
  <div class="body_right">
    <div class="right_container">
      <div class="right_title">
        <div class="title">담당자 등록</div>
        <div class="description">
          담당자 정보를 등록합니다. <span class="text_red">(* 필수항목)</span>
        </div>
        <article class="right_body">
          <div class="tbl_search tbl_info">
            <div class="part_title">담당자정보</div>
            <table>
              <colgroup>
                <col style="width: 18%" class="col_width26" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>업체명<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <template v-if="partnerCompanys.length > 0">
                        <button
                          v-for="partnercompany in partnerCompanys"
                          :key="partnercompany.id"
                          type="button"
                          :class="{
                            on: selectedpartnerCompany === partnercompany.id,
                          }"
                          @click="selectPartnerCompany(partnercompany.id)"
                        >
                          {{ partnercompany.companyName }}
                        </button>
                      </template>
                      <!-- 업체가 없을 때 메시지 표시 -->
                      <template v-else> 등록된 업체가 없습니다. </template>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>담당자 이름<span class="text_red">*</span></th>
                  <td>
                    <input
                      type="text"
                      class="w_250"
                      placeholder="담당자 이름을 입력해주세요"
                      v-model="managerName"
                      ref="managerName"
                    />
                  </td>
                </tr>
                <tr>
                  <th>담당자 직급(직책)<span class="text_red">*</span></th>
                  <td>
                    <input
                      type="text"
                      class="w_250"
                      placeholder="담당자 직급(직책)을 입력해주세요"
                      v-model="managerUserPosition"
                      ref="managerUserPosition"
                    />
                  </td>
                </tr>
                <tr>
                  <th>담당자 번호<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td mobile_number">
                      <select v-model="partnerManagerPhoneFirstPart">
                        <option>010</option>
                        <option>011</option>
                        <option>016</option>
                        <option>017</option>
                        <option>018</option>
                        <option>019</option>
                      </select>
                      -
                      <input
                        type="text"
                        class="w_55"
                        maxlength="4"
                        v-model="partnerManagerPhoneSecondPart"
                        ref="partnerManagerPhoneSecondPart"
                      />
                      -
                      <input
                        type="text"
                        class="w_55"
                        maxlength="4"
                        v-model="partnerManagerPhoneThirdPart"
                        ref="partnerManagerPhoneThirdPart"
                      />
                      <span v-if="isPhoneDuplicated" class="text_red"
                        >이미 등록된 번호입니다.</span
                      >
                      <span
                        v-else-if="phoneChecked && !isPhoneDuplicated"
                        class="text_green"
                        >사용 가능한 번호입니다.</span
                      >
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>지역<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <select
                        class="w_250"
                        v-model="selectedArea"
                        @change="handleAreaChange"
                      >
                        <option value="0">전체보기</option>
                        <option
                          v-for="area in areas"
                          :key="area.id"
                          :value="area.id"
                        >
                          {{ area.areaName }}
                        </option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>특이사항</th>
                  <td>
                    <div class="inner_td">
                      <textarea
                        placeholder="특이사항을 입력하세요. "
                        v-model="specialMemo"
                        ref="specialMemo"
                      ></textarea>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn_bottom_a">
            <button type="button" class="on" @click="saveManager">등록</button>
            <button type="button" @click="goToManagerList">취소</button>
          </div>
        </article>
      </div>
      <!-- 삼성인터넷브라우저에서 안되서 원인 파악하다가 스타일문제로 확인! 임시방편임 -->
      <div style="margin-top: 100px"></div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/apiClient"; // 설정 파일에서 가져온 axios 인스턴스
import { useToast } from "vue-toastification";

export default {
  name: "ManagersAdd",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      partnerCompanys: [], // 파트너 회사 목록을 저장할 배열
      checkMobiles: [],
      selectedpartnerCompany: "", // 선택된 파트너 회사

      partnerManagerPhoneFirstPart: "010", // 담당자 휴대폰번호 첫 번째 부분
      partnerManagerPhoneSecondPart: "", // 담당자 휴대폰번호 두 번째 부분
      partnerManagerPhoneThirdPart: "", // 담당자 휴대폰번호 세 번째 부분

      isPhoneDuplicated: false, // 번호 중복 여부
      phoneChecked: false, // 번호 확인 여부

      selectedArea: "0", // 전체보기 기본 값 설정
      areas: [], // API에서 가져온 지역 목록을 저장할 배열
    };
  },
  watch: {
    // 세 개의 번호 부분이 모두 입력되었을 때 API 호출
    partnerManagerPhoneFirstPart() {
      this.checkPhoneNumber();
    },
    partnerManagerPhoneSecondPart() {
      this.checkPhoneNumber();
    },
    partnerManagerPhoneThirdPart() {
      this.checkPhoneNumber();
    },
  },
  computed: {
    userId() {
      return this.$store.getters.getUserid;
    },
    userName() {
      return this.$store.getters.getUsername;
    },
    userType() {
      return this.$store.getters.getUsertype;
    },
    userPermission() {
      return this.$store.getters.getUserpermission;
    },
  },
  methods: {
    async checkPhoneNumber() {
      // 모든 번호가 입력되었을 때만 API 호출
      if (
        this.partnerManagerPhoneSecondPart.length === 4 &&
        this.partnerManagerPhoneThirdPart.length === 4
      ) {
        const fullPhoneNumber = `${this.partnerManagerPhoneFirstPart}-${this.partnerManagerPhoneSecondPart}-${this.partnerManagerPhoneThirdPart}`;

        try {
          const response = await apiClient.post("/api/Manager/check-phone", {
            userPhone: fullPhoneNumber,
          });

          if (response.status === 200) {
            const data = JSON.parse(response.data);
            this.checkMobiles = Array.isArray(data.data) ? data.data : [];

            if (this.checkMobiles.length > 0) {
              this.isPhoneDuplicated = true;
              this.phoneChecked = true; // 확인 완료 표시
            } else {
              this.isPhoneDuplicated = false; // 중복된 번호가 없으면 중복 표시 해제
              this.phoneChecked = true; // 확인 완료 표시
            }
          }
        } catch (error) {
          console.error("Error checking phone number:", error);
          this.isPhoneDuplicated = false;
          this.phoneChecked = false;
        }
      } else {
        this.isPhoneDuplicated = false; // 번호가 완성되지 않으면 중복 체크 해제
        this.phoneChecked = false; // 확인 완료되지 않음
      }
    },
    async fetchAreas() {
      try {
        const searchParam = {
          PageSize: 100,
          Page: "1",
        };
        const response = await apiClient.post(
          "/api/Area/all-area-list",
          searchParam
        );
        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.areas = Array.isArray(data.data) ? data.data : [];
          console.log(this.areas);
        }
      } catch (error) {
        console.error("Error fetching areas:", error);
      }
    },
    async fetchPartnerCompanys() {
      try {
        const searchParam = {
          PageSize: 100,
          Page: "1",
        };

        const response = await apiClient.post(
          "/api/Company/all-company-list",
          searchParam
        ); // 예시 API 엔드포인트
        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.partnerCompanys = Array.isArray(data.data) ? data.data : [];
          console.log(this.partnerCompanys);
        }
      } catch (error) {
        console.error("Error fetching partner companys:", error);
      }
    },
    selectPartnerCompany(partnercompanyId) {
      this.selectedpartnerCompany = partnercompanyId;
    },
    goToManagerList() {
      this.$router.push({ path: "/managers/list" });
    },
    async saveManager() {
      if (this.isPhoneDuplicated) {
        this.toast.error("이미 등록된 번호입니다. 다른 번호를 입력해주세요.", {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        return; // 중복된 번호일 경우 저장을 차단하고 함수를 종료
      }

      if (this.checkFields()) {
        try {
          const response = await apiClient.post("/api/Manager/manager-add", {
            CompanyId: this.selectedpartnerCompany,
            UserName: this.managerName,
            UserPosition: this.managerUserPosition,
            UserPhone: `${this.partnerManagerPhoneFirstPart}-${this.partnerManagerPhoneSecondPart}-${this.partnerManagerPhoneThirdPart}`,
            SpecialMemo: this.specialMemo,
            LoginId: localStorage.getItem("userid"),
            AreaId: this.selectedArea,
            // 필요한 다른 필드 추가
          });
          if (response.status === 200) {
            console.log("담당자 정보가 성공적으로 등록되었습니다.");

            this.toast.success("담당자 정보가 성공적으로 등록되었습니다.", {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });
            this.goToManagerList();
          }
        } catch (error) {
          console.error("Error saving manager data:", error);
          this.toast.error("담당자 정보가 등록 중 오류가 발생했습니다.", {
            position: "top-center", // 메시지 위치
            timeout: 1500, // 3초 동안 표시
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true, // 진행 표시줄 숨기기
            closeButton: false, // X 버튼 숨기기
          });
        }
      }
    },
    checkFields() {
      if (!this.selectedpartnerCompany) {
        this.toast.error("업체명를 선택해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });

        return false;
      }
      if (!this.managerName) {
        this.$refs.managerName.focus();
        this.toast.error("담당자 이름을 입력해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return false;
      }
      if (!this.managerUserPosition) {
        this.$refs.managerUserPosition.focus();
        this.toast.error("담당자 직급(직책)을 입력해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return false;
      }
      if (!this.partnerManagerPhoneSecondPart) {
        this.$refs.partnerManagerPhoneSecondPart.focus();
        this.toast.error("담당자 상세번호(가운데자리)를 입력해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return false;
      }
      if (!this.partnerManagerPhoneThirdPart) {
        this.$refs.partnerManagerPhoneThirdPart.focus();
        this.toast.error("담당자 상세번호(마지막자리) 입력해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return false;
      }

      if (this.selectedArea === "0") {
        // 전체보기 (기본값) 또는 선택되지 않은 상태
        this.toast.error("지역을 선택해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        return false;
      }

      return true;
    },
  },
  mounted() {
    this.fetchAreas(); // 컴포넌트가 마운트될 때 회사 정보를 가져옵니다.
    this.fetchPartnerCompanys(); // 소속업체 목록을 가져옴
  },
};
</script>
